import { useTranslation } from "react-i18next";
import { Badge, BadgeVariant } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { JobStatus } from "@/hooks/useJobs";

const statusStyles: { [key in JobStatus]: BadgeVariant } = {
  [JobStatus.IN_PROGRESS]: "default",
  [JobStatus.COMPLETED]: "success",
  [JobStatus.ERROR]: "error",
  [JobStatus.PENDING_UPLOAD]: "default",
  [JobStatus.QUEUED]: "default",
  [JobStatus.DELETED]: "default",
};

export const JobBadge = ({ status }: { status: JobStatus }) => {
  const { t } = useTranslation(["home"]);

  const showTooltip =
    status === JobStatus.IN_PROGRESS || status === JobStatus.QUEUED;

  const badge = (
    <Badge variant={statusStyles[status] as BadgeVariant}>{status}</Badge>
  );

  return (
    <div className="flex-6 text-center">
      {showTooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>{badge}</TooltipTrigger>
            <TooltipContent>
              <p>{t("job.processingTooltip")}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        badge
      )}
    </div>
  );
};
